import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  playerContainer: {
    position: 'relative',
  },
  uploadLayer: {
    width: '100%',
    position: 'absolute',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    top: 0,
    left: 0,
    borderRadius: 4,
    overflow: 'hidden',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  progressLoader: {
    color: theme.palette.colors.white,
  },
  uploadProgressLabel: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.colors.white,
    width: '100%',
    height: '100%',
  },
  icon: {
    fill: theme.palette.colors.white,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/VideoUploader/components/Uploader/useStyles.js